import emptyState from "./emptyState";
import { actionTypes } from "./actions";
import { immutableSet } from "../../../utils/immutable";

import { SHOW_IDENTIFIER } from "./constants";

interface IAction {
  type: any;
  payload: any;
}

const ACTION_HANDLERS = {
  [actionTypes.SHOW_AND_CLOSE_SIDEBAR]: (state: any, action: any) =>
    immutableSet([SHOW_IDENTIFIER], action.show, state),
};

// Reducer
export default function communicationReducer(
  state = emptyState,
  action: IAction
) {
  const handler = ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
